export default "__VITE_ASSET__cd16aff8__"